import { withRouter } from "next/router";
import { inject, observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import EntryBlock from "../entryBlock";
import ParnersBlock from "../partnersBlock";
import ReviewsBlock from "../reviewsBlock";
import SouvenirsBlock from "../souvenirsBlock";

import styles from "./styles.module.scss";
import QuestionsBlock from "../../questionsBlock";
import { QUESTIONS } from "../constants";

const SouvenirPage = (props) => {
  const { souvenirStore, authStore } = props;
  const [souvenirsStatus, setSouvenirsStatus] = useState();
  const [souvenirs, setSouvenirs] = useState();
  const [donationsStatus, setDonationsStatus] = useState({
    hasConfirmedDonationsAfterReg: false,
    hasDonationsInThisYear: false,
    hasConfirmedEmail: false,
    hasConfirmedPhone: false,
    hasEmailInSendsayStoplist: true,
  });
  const [error, setError] = useState(null);
  const isRequestInProgress = useRef(false);

  const fetchData = async () => {
    try {
      const res = await souvenirStore?.getGiftStatus();

      const {
        request_status,
        has_confirmed_donations_after_reg,
        has_donations_in_this_year,
        has_confirmed_email,
        has_email_in_sendsay_stoplist,
        has_confirmed_phone,
        ...info
      } = res;

      setDonationsStatus({
        hasConfirmedDonationsAfterReg: has_confirmed_donations_after_reg,
        hasDonationsInThisYear: has_donations_in_this_year,
        hasConfirmedEmail: has_confirmed_email,
        hasConfirmedPhone: has_confirmed_phone,
        hasEmailInSendsayStoplist: has_email_in_sendsay_stoplist,
      })
      setSouvenirs(info)
      setSouvenirsStatus(request_status)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (authStore?.user?.id) fetchData()
  }, [])

  const getSouvenirs = async () => {
    if (isRequestInProgress.current) return;

    if (['no_request', 'declined', 'received'].includes(souvenirsStatus)) {
      try {
        isRequestInProgress.current = true;

        await souvenirStore?.getGifts();
        await fetchData();

      } catch (error) {
        setError(error?.response?.data?.detail[0] || "Что-то пошло не так, попробуйте повторить попытку позже")
      } finally {
        isRequestInProgress.current = false;
      }
    }
  };

  const cancelRequest = async () => {
    try {
      await souvenirStore.cancelGiftRequest();
      await fetchData()
    } catch (error) { }
  }

  return (
    <section className={styles.Souvenir}>
      <EntryBlock />
      <SouvenirsBlock
        souvenirs={souvenirs}
        souvenirsStatus={authStore?.user?.id ? souvenirsStatus : 'auth'}
        donationsStatus={donationsStatus}
        getSouvenirs={getSouvenirs}
        cancelRequest={cancelRequest}
        userEmail={authStore?.user?.email}
        error={error}
      />
      {
        ['no_request', 'declined'].includes(souvenirsStatus) || !!!authStore?.user?.id &&
        <ReviewsBlock />
      }
      <QuestionsBlock questions={QUESTIONS} />
      <ParnersBlock />
    </section>
  );
};

export default inject(
  "souvenirStore",
  "authStore"
)(observer(withRouter(SouvenirPage)));
